
        import * as module0 from './contents/bitcoin.js';import * as module1 from './contents/email.js';import * as module2 from './contents/pay.js';import * as module3 from './contents/phone.js';import * as module4 from './contents/raw.js';import * as module5 from './contents/url.js';import * as module6 from './contents/vcard.js';import * as module7 from './contents/wifi.js'

        const modules = [module0,module1,module2,module3,module4,module5,module6,module7];

        export default modules;
        export const filenames = ['./contents/bitcoin.js','./contents/email.js','./contents/pay.js','./contents/phone.js','./contents/raw.js','./contents/url.js','./contents/vcard.js','./contents/wifi.js']
      